<template>
   <div class="flex justify-between mb-2">
      <HeadlessMenu
        as="div"
        v-for="head in headers"
        class="relative inline-block text-left w-72"
      >
        <HeadlessMenuButton
          class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-transparent text-Primary-600 px-3 py-2 text-sm font-medium  hover:bg-gray-50 uppercase"
          :class="{disabled: props.hideOptionsFor == head.text}"
        >
          {{ head.text }}
          <ChevronDownIcon
            class="-mr-1 h-5 w-5 text-gray-400"
            aria-hidden="true"
            :class="{hidden: props.hideOptionsFor == head.text}"
          />
        </HeadlessMenuButton>
        <transition
          enter-active-class="transition ease-out duration-100"
          enter-from-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-from-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <HeadlessMenuItems
            class="absolute left-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <div class="py-1">
              <HeadlessMenuItem
                v-slot="{ active }"
                v-for="sortMethod in sortBy"
              >
                <a
                  :class="[
                    sortMethod === head.sortBy
                      ? 'bg-gray-100 text-gray-900'
                      : 'text-gray-700',
                    'block px-4 py-2 text-sm',
                  ]"
                  @click.prevent="head.sortBy = sortMethod"
                  href="#"
                >
                  {{ sortMethod }}
                </a>
              </HeadlessMenuItem>
            </div>
          </HeadlessMenuItems>
        </transition>
      </HeadlessMenu>
    </div>
</template>

<script setup>
import { sortByTypes } from "@/assets/configStrings.js";

import { ChevronDownIcon } from "@heroicons/vue/20/solid";
const sortBy = [sortByTypes.Auto, sortByTypes.Name, sortByTypes.Value];

   const props = defineProps({
      headers: {
         type: Array,
         required: true,
      },
      hideOptionsFor: {
         type: String,
         default: "",
      },
   });
</script>

<style lang="scss" scoped>

</style>